import { CaseRotationStatus } from '#entities';
import { EClusterData } from '#shared';

import { SvgClusterCaseLabel } from './FlyingCaseLabel';

import type {
  CaseClusterType,
  ClusterData,
  NewCaseClusterType,
} from '#entities';

type ClusterItem = NewCaseClusterType | CaseClusterType;

interface Props {
  clusters: Array<ClusterItem>;
  handleSelectCase?: (id: string) => void;
  isRotationActive?: boolean;
  activeRotationStatus?: CaseRotationStatus;
  labelPositions: Record<string, { x: number; y: number } | undefined>;
}

export const ClustersSvgLayer = ({
  clusters,
  handleSelectCase,
  isRotationActive,
  activeRotationStatus,
  labelPositions,
}: Props) => (
  <g data-layer="clusters-labels">
    {clusters.map(group => {
      const item = group;

      if (
        item.type !== EClusterData.Case &&
        item.type !== EClusterData.NewCase
      ) {
        return null;
      }

      const pos = labelPositions[item.data.id];
      return (
        <SvgClusterCaseLabel
          key={item.data.id}
          item={item as ClusterData<CaseClusterType>}
          position={pos}
          handleSelectCase={handleSelectCase}
          isRotationActive={isRotationActive}
          activeRotationStatus={activeRotationStatus}
        />
      );
    })}
  </g>
);
